import { useCallback, useLayoutEffect, useRef } from "react";

import { offset } from "@floating-ui/react";

import {
  useFloatingWindowOrder,
  useFloatingWindowsActions,
} from "src/base-components/FloatingWindow/hooks";
import { FlowJsonSchemaWindowData } from "src/schema/window/FlowJsonSchemaWindow";

const FLOW_JSON_SCHEMA_WINDOW_ID = "flow-json-schema";

export const useFlowJsonSchemaWindow = () => {
  const { open: openWindowInternal, close: closeWindowInternal } =
    useFloatingWindowsActions();
  const windowOrder = useFloatingWindowOrder(FLOW_JSON_SCHEMA_WINDOW_ID);
  const windowTargetRef = useRef<HTMLDivElement | null>(null);

  const openWindow = useCallback(
    (data: FlowJsonSchemaWindowData) => {
      openWindowInternal(
        {
          id: FLOW_JSON_SCHEMA_WINDOW_ID,
          type: "flow-json-schema",
          target: windowTargetRef,
          positionOptions: {
            placement: "right-start",
            middleware: [offset({ alignmentAxis: 10, mainAxis: 10 })],
          },
        },
        data,
      );
    },
    [openWindowInternal],
  );

  const closeWindow = useCallback(() => {
    closeWindowInternal(FLOW_JSON_SCHEMA_WINDOW_ID);
  }, [closeWindowInternal]);

  useLayoutEffect(() => {
    const schemaEditor = document.querySelector("[data-loc=side-pane-schema]");
    windowTargetRef.current = schemaEditor as HTMLDivElement;
  }, []);

  return {
    openWindow,
    closeWindow,
    isOpen: !!windowOrder,
  };
};
